import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
function App() {
  return (
    <HashRouter>
      <Routes>
        <Route exact path="/" element={<Login />} />
      </Routes>
      <ToastContainer theme="colored" />
    </HashRouter>
  );
}

export default App;
